import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';

const { Search } = Input;

@inject('BookingItemStore')
@observer
class BookingSubCategorySearchModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('Sub Category'),
                dataIndex: 'name',
                key: 'name',
                width: '80%'
            },
            {
                title: t('Action'),
                dataIndex: 'id',
                key: 'id',
                width: '10%',
                render: id => (
                    <span>
                        <Button onClick={() => this.selectSubCategoryOnClick(id)} type='primary'>
                            {t('Select')}
                        </Button>
                    </span>
                ),
            },
        ]
    }

    // ON CHANGE

    subcategoryOnChange = e => {
        this.props.BookingItemStore.setSubCategorySearchValue(e.target.value);
        this.props.BookingItemStore.searchSubCategory();
    }

    // ON CLICK

    selectSubCategoryOnClick = subcategoryId => {
        this.props.BookingItemStore.searchSubCategorySelected(subcategoryId);
        this.props.BookingItemStore.setShowBookingSubCategorySearchModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            bookingSubCategoryFilter,
            subCategorySearchValue
        } = this.props.BookingItemStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder={t('Search Sub Category')} value={subCategorySearchValue} onChange={this.subcategoryOnChange} />
                <Table columns={this.getColumns()} dataSource={bookingSubCategoryFilter} />
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(BookingSubCategorySearchModalPage);
